import { useEffect, useState } from 'react'
import { ExpandableTable } from '@/shared/components/expandable-table'
import { sum } from 'lodash'
import { klasses as klassesTranslate } from '@/constants/klasses'

export const DetailComplianceTable = ({ data = {} }) => {
  const [detailComplianceData, setDetailComplianceData] = useState([])

  const formatMonthlyData = ({ details = {} }) => {
    const klasses = Object.keys(details)
    let result = []

    klasses.forEach((klass) => {
      const currentDetail = details[klass]
      const attachmentTypes = Object.keys(currentDetail)
      attachmentTypes.forEach((attachmentType) => {
        const total = sum(Object.values(currentDetail[attachmentType]))
        const { approved } = currentDetail[attachmentType]
        result = [
          ...result,
          {
            klass: klassesTranslate[klass],
            name: attachmentType,
            approved,
            total
          }
        ]
      })
    })

    return result
  }

  useEffect(() => {
    if (!Object.keys(data).length) {
      setDetailComplianceData([])
      return
    }

    const monthKeys = Object.keys(data)
    const map = new Map()
    const addToMap = (obj) => {
      const key = obj.klass + obj.name
      if (map.has(key)) {
        const existingObj = map.get(key)
        existingObj.approved += obj.approved
        existingObj.total += obj.total
      } else {
        map.set(key, { ...obj })
      }
    }

    monthKeys.forEach(monthKey => {
      const currentMonthData = formatMonthlyData(data[monthKey])
      currentMonthData.forEach(obj => addToMap(obj))
    })
    const resultArray = Array.from(map.values()).map(obj => ({
      klass: obj.klass,
      name: obj.name,
      compliance: `${obj.approved}/${obj.total}`
    }))

    setDetailComplianceData(resultArray)
  }, [data])
  return (
    <ExpandableTable
      data={detailComplianceData}
      columns={[
        { key: 'klass', label: 'Módulo' },
        { key: 'name', label: 'Documento' },
        { key: 'compliance', label: 'Cumplimiento' }
      ]}
    />
  )
}
